/**
 * Transient "pin this project & show only pinned" intent from the
 * quick-search palette.
 *
 * Lives as a module-level value — same lifetime contract as
 * `focus-intent.ts`. Set by `QuickSearchDialog.handlePin` right
 * before it navigates to `/?projectId=…`. Consumed (read-and-cleared
 * atomically) by `ProjectTree` on mount AND by its `pin-and-focus-project`
 * event listener, whichever fires first.
 *
 * Why both an event AND an intent? When the user pins from the
 * dashboard route the tree is already mounted and the event delivers
 * instantly. When the user pins from a non-dashboard route (admin
 * page, settings, etc.) the tree isn't mounted yet, so the event has
 * no listener — the durable intent ensures the pin is applied as soon
 * as the tree mounts after navigation.
 */

interface PinIntent {
  projectId: string;
  title: string;
}

let pending: PinIntent | null = null;

export function setPinIntent(intent: PinIntent) {
  pending = intent;
}

export function consumePinIntent(): PinIntent | null {
  const value = pending;
  pending = null;
  return value;
}
